import { Users, Calendar, Award, CheckCircle } from 'lucide-react'

const About = () => {
  const stats = [
    {
      icon: <Calendar className="text-blue-600" size={32} />,
      number: "18+",
      label: "Yıl Deneyim"
    },
    {
      icon: <Users className="text-blue-600" size={32} />,
      number: "5000+",
      label: "Mutlu Müşteri"
    },
    {
      icon: <Award className="text-blue-600" size={32} />,
      number: "%100",
      label: "Memnuniyet Garantisi"
    },
    {
      icon: <CheckCircle className="text-blue-600" size={32} />,
      number: "50+",
      label: "Uzman Personel"
    }
  ];

  return (
    <section id="hakkimizda" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              Hakkımızda
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              2007 yılından bu yana İstanbul'da faaliyet gösteren Bektas Temizlik, 
              profesyonel temizlik hizmetleri alanında öncü firmalardan biridir. 
              Müşteri memnuniyetini ön planda tutarak, kaliteli ve güvenilir hizmet sunmaktayız.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Deneyimli ekibimiz, modern ekipmanlar ve çevre dostu temizlik ürünleriyle 
              ev, ofis ve işyerlerinizde en üst düzeyde temizlik standardını sağlıyoruz. 
              Sigortalı personel ve müşteri güvencesi ile hizmet veriyoruz.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-500 flex-shrink-0" size={20} />
                <span className="text-gray-700">ISO 9001 Kalite Yönetim Sistemi Sertifikası</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-500 flex-shrink-0" size={20} />
                <span className="text-gray-700">Çevre dostu temizlik ürünleri kullanımı</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-500 flex-shrink-0" size={20} />
                <span className="text-gray-700">7/24 müşteri destek hattı</span>
              </div>
              <div className="flex items-center space-x-3">
                <CheckCircle className="text-green-500 flex-shrink-0" size={20} />
                <span className="text-gray-700">Sigortalı ve eğitimli personel kadrosu</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=1200&auto=format&fit=crop" 
              alt="Profesyonel Temizlik Ekibimiz" 
              className="w-full h-96 object-cover rounded-2xl shadow-xl"
            />
            <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-6 rounded-2xl shadow-xl">
              <div className="text-2xl font-bold">15+</div>
              <div className="text-sm opacity-90">Yıl Tecrübe</div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="inline-flex items-center justify-center w-16 h-16 mb-4">
                {stat.icon}
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{stat.number}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;